import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import consumer_trains_common_queryTheCitySite
    from "../../../../../../lib/data-service/haolv-default/consumer_trains_common_queryTheCitySite";
import to_string from "nllib/src/convert/to_string";
import wait_some_seconds from "nllib/src/common/wait_some_seconds";
import get_uuid from "nllib/src/common/get_uuid";

import tree_to_list from "nllib/src/tree-helper/tree_to_list";
import list_to_tree from "./list-to-tree";
import get_child_node_list from "nllib/src/tree-helper/get_child_node_list";
import get_parent_node_list from "./lib/tree-helper/get_parent_node_list";

export default {
    props: {
        value: {
            type: Array,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            value_for_v_model: [],
            temp_value_for_v_model: [],

            left_tree: {
                data: [],
                all_node_list: [],
                all_entity_list: [],

                filter_text: ``,
                default_expand_all: true,
                loading: false,
            },

            right_tree: {
                data: [],

                filter_text: ``,
            },

            dialog: {
                show: false,
            },

            defer_get_data_source_completed: Q.defer(),
            defer_left_tree_init_all_node_list_completed: Q.defer(),

            init_parameter: {
                entity_define: {
                    property_name_for_id: `id`,
                    property_name_for_list_id: `treeId`,
                    property_name_for_name: `name`,
                    property_name_for_children: `children`,
                    property_name_for_parent_id: `parent_id`,
                    property_name_for_order_index: `order_index`,
                },
                node_define: {
                    property_name_for_parent: `parent`,
                    property_name_for_children: `childNodes`,
                },

                left_tree: {
                    default_expand_all: true,
                },

                right_tree: {
                    default_expand_all: true,
                },

                dialog: {
                    title: `请选择`,
                    width: `600px`,
                },

                get_data_source() {
                    const get_data_type_000 = function () {
                        const all_entity_list = [
                            {
                                id: 1,
                                parent_id: ``,
                                name: '一级 1',
                            },
                            {
                                id: 4,
                                parent_id: 1,
                                name: '二级 1-1',
                            },
                            {
                                id: 9,
                                parent_id: 4,
                                name: '三级 1-1-1'
                            },
                            {
                                id: 10,
                                parent_id: 4,
                                name: '三级 1-1-2'
                            },
                            {
                                id: 2,
                                parent_id: ``,
                                name: '一级 2',
                            },
                            {
                                id: 5,
                                parent_id: 2,
                                name: '二级 2-1'
                            },
                            {
                                id: 6,
                                parent_id: 2,
                                name: '二级 2-2'
                            },
                            {
                                id: 3,
                                parent_id: ``,
                                name: '一级 3',
                            },
                            {
                                id: 7,
                                parent_id: 3,
                                name: '二级 3-1'
                            },
                            {
                                id: 8,
                                parent_id: 3,
                                name: '二级 3-2'
                            },
                            {
                                id: 11,
                                parent_id: ``,
                                name: '一级 4',
                            },
                        ];

                        _.each(all_entity_list, function (entity, index) {
                            entity.order_index = index;
                        });

                        const data = {
                            type: `000`,
                            all_entity_list,
                        };
                        return data;
                    };

                    const get_data_type_100 = function () {
                        const tree = [
                            {
                                id: 1,
                                parent_id: ``,
                                name: '一级 1',
                                children: [
                                    {
                                        id: 4,
                                        parent_id: 1,
                                        name: '二级 1-1',
                                        children: [
                                            {
                                                id: 9,
                                                parent_id: 4,
                                                name: '三级 1-1-1'
                                            },
                                            {
                                                id: 10,
                                                parent_id: 4,
                                                name: '三级 1-1-2'
                                            },
                                        ]
                                    }
                                ]
                            },
                            {
                                id: 2,
                                parent_id: ``,
                                name: '一级 2',
                                children: [
                                    {
                                        id: 5,
                                        parent_id: 2,
                                        name: '二级 2-1'
                                    },
                                    {
                                        id: 6,
                                        parent_id: 2,
                                        name: '二级 2-2'
                                    }
                                ]
                            },
                            {
                                id: 3,
                                parent_id: ``,
                                name: '一级 3',
                                children: [
                                    {
                                        id: 7,
                                        parent_id: 3,
                                        name: '二级 3-1'
                                    },
                                    {
                                        id: 8,
                                        parent_id: 3,
                                        name: '二级 3-2'
                                    }
                                ]
                            },
                        ];

                        const all_entity_list = tree_to_list({
                            tree: tree,
                            property_name_for_children: `children`,
                        });

                        _.each(all_entity_list, function (entity, index) {
                            entity.order_index = index;
                        });

                        const data = {
                            tree: tree,
                            type: `100`,
                        };
                        return data;
                    };

                    const d = get_data_type_000();
                    // const d = get_data_type_100();

                    return Q.when()
                        .then(function () {
                            return wait_some_seconds({
                                seconds: 1,
                            });
                        })
                        .then(function () {
                            return Q.resolve(d);
                        })
                        .catch(function (ex) {
                            if (ex) {
                                const enable_log_error = !ex.disable_log_error;
                                if (enable_log_error) {
                                    console.error(ex);
                                    console.trace();
                                    if (ex.stack) {
                                        console.error(ex.stack);
                                    }
                                }
                            }
                            return Q.reject(ex);
                        })
                        ;
                },

                btn_ok_click_event_handler() {
                    console.log(`__btn_ok_click_event_handler`);
                },

                btn_cancel_click_event_handler() {
                    console.log(`__btn_cancel_click_event_handler`);
                },
            },

        };
    },

    computed: {
        props_for_tree() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;
            const property_name_for_order_index = __this.init_parameter.entity_define.property_name_for_order_index;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            const p = {
                children: property_name_for_children,
                label: property_name_for_name,
            };
            return p;
        },
    },

    watch: {
        'left_tree.filter_text'(pNewValue, pOldValue) {
            const __this = this;
            __this.$refs.left_tree.filter(pNewValue);
        },

        'right_tree.filter_text'(pNewValue, pOldValue) {
            const __this = this;
            __this.$refs.right_tree.filter(pNewValue);
        },

        value: {
            handler(pNewValue, pOldValue) {
                const __this = this;
                __this.value_for_v_model = pNewValue;
            },
            immediate: true,
            // deep: true,
            //参考：https://blog.csdn.net/Liu_yunzhao/article/details/95395427
        },

        value_for_v_model: {
            handler(pNewValue, pOldValue) {
                const __this = this;
                __this.__init_value_for_v_model().then(function () {
                    __this.$emit('input', pNewValue);
                });
                __this.$emit('input', pNewValue);
            },
            immediate: true,
            // deep: true,
            //参考：https://blog.csdn.net/Liu_yunzhao/article/details/95395427
        }
    },

    methods: {
        __init_data_source() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_list_id = __this.init_parameter.entity_define.property_name_for_list_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;
            const property_name_for_order_index = __this.init_parameter.entity_define.property_name_for_order_index;

            const get_data_source = __this.init_parameter.get_data_source;

            return Q.when()
                .then(function () {
                    __this.left_tree.loading = true;
                    return get_data_source();
                })
                .then(function (data) {
                    if (!data) {
                        const msg = '__init_data_source parameter error, code=001';
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    //000|100
                    //000:传入all_entity_list
                    //100:传入tree_data
                    const type = data.type || `000`;

                    const process_type_000 = function () {
                        const all_entity_list = data.all_entity_list;
                        if (!_.isArray(all_entity_list)) {
                            const msg = '__init_data_source:process_type_000 parameter error, code=001';
                            console.error(msg);
                            console.trace();
                            return Q.reject({msg: msg});
                        }

                        const tree_data = list_to_tree({
                            list: all_entity_list,
                            property_name_for_id: property_name_for_list_id || property_name_for_id,
                            property_name_for_parent_id,
                            property_name_for_children,
                        });

                        __this.left_tree.all_entity_list = all_entity_list;
                        __this.left_tree.data = tree_data;
                        __this.left_tree.loading = false;
                        __this.defer_get_data_source_completed.resolve();
                    };

                    const process_type_100 = function () {
                        const tree = data.tree;
                        if (!_.isArray(tree)) {
                            const msg = '__init_data_source:process_type_100 parameter error, code=001';
                            console.error(msg);
                            console.trace();
                            return Q.reject({msg: msg});
                        }

                        const all_entity_list = tree_to_list({
                            tree,
                            property_name_for_id: property_name_for_list_id || property_name_for_id,
                            property_name_for_parent_id,
                            property_name_for_children,
                        });

                        __this.left_tree.all_entity_list = all_entity_list;
                        __this.left_tree.data = tree;
                        __this.left_tree.loading = false;
                        __this.defer_get_data_source_completed.resolve();
                    };

                    if (type === `000`) return process_type_000();
                    if (type === `100`) return process_type_100();

                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
                ;

        },

        __init_tree() {
            const __this = this;

            Q.when()
                .then(function () {
                    return __this.defer_get_data_source_completed.promise;
                })
                .then(function () {
                    __this.$nextTick(function () {
                        __this.__left_tree_init_all_node_list();
                    });
                })
                .catch(function (ex) {
                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                })
            ;

            return __this.defer_left_tree_init_all_node_list_completed.promise;
        },

        __init_value_for_v_model() {
            const __this = this;

            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;

            const __get_tree_data_by_id_list = __this.__get_tree_data_by_id_list;

            return Q.when()
                .then(function () {
                    return Q.all([
                        __this.defer_get_data_source_completed.promise,
                        __this.defer_left_tree_init_all_node_list_completed.promise,
                    ]);
                })
                .then(function () {
                    const all_node_list = __this.left_tree.all_node_list;
                    const all_entity_list = __this.left_tree.all_entity_list;

                    //修正value_for_v_model的非法值
                    if (!_.isArray(__this.value_for_v_model)) {
                        const msg = `__init_value_for_v_model parameter error, code=001`;
                        console.error(msg);
                        console.trace();
                        return Q.reject({msg: msg});
                    }

                    __this.temp_value_for_v_model = __this.value_for_v_model;

                    const right_tree_data = __get_tree_data_by_id_list({
                        id_list: __this.temp_value_for_v_model,
                    });
                    __this.right_tree.data = right_tree_data;

                })
                .catch(function (ex) {
                    console.error(ex);
                    console.trace();
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
                ;
        },

        //通过id_list，获取tree_data(entity，不是node)
        __get_tree_data_by_id_list({id_list}) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;
            const property_name_for_order_index = __this.init_parameter.entity_define.property_name_for_order_index;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            const all_node_list = __this.left_tree.all_node_list;
            const all_entity_list = __this.left_tree.all_entity_list;
            //console.log(id_list);
            const selected_entity_list = _.chain(id_list)
                .map(function (m) {
                    const node_001 = _.chain(all_node_list)
                        .find(function (__m) {
                            //console.log(__m);
                            //console.log(__m ? __m.data : 'wu');
                            const entity = __m ? __m.data : {};
                            const id = entity[property_name_for_id];
                            //console.log(m === id)
                            return m === id;
                        })
                        .value()
                    ;
                    //console.log('node_001', node_001)
                    return node_001;
                }).filter((m)=>{
                    //console.log('m11', m);
                    return m
                })
                .flatten()
                .map(function (m) {
                    //console.log('m', m);
                    const entity = m && m.data;
                    return entity[property_name_for_id]
                })
                .uniq()
                .map(function (m) {
                    const aa =  _.chain(all_entity_list)
                        .find(function (__m) {
                            const id = __m[property_name_for_id];
                            return id === m && __m.isProvince === 0;
                        })
                        .value()
                    ;
                    return aa;
                })
                .sortBy(function (m) {
                    return m[property_name_for_order_index];
                })
                .value()
            ;


            return selected_entity_list;
        },

        //通过node，获取要处理的处于叶子结点的id_list
        //用于left_tree的add操作，和right_tree的remove操作
        __get_id_list_for_tree_add_or_remove({node}) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            let id_list_001;
            //如果当前选择的是叶子结点
            if (node.isLeaf) {
                const entity = node.data;
                const id = entity[property_name_for_id];
                id_list_001 = [
                    id,
                ];
            } else {
                const node_list_001 = get_child_node_list({
                    node,
                    property_name_for_children: node_property_name_for_children,
                });

                const node_list_002 = _.chain(node_list_001)
                    .filter(function (m) {
                        return m.isLeaf;
                    })
                    .value()
                ;

                const entity_list_002 = _.chain(node_list_002)
                    .map(function (m) {
                        return m.data;
                    })
                    .value()
                ;

                const __id_list_002 = _.chain(entity_list_002)
                    .map(function (m) {
                        return m[property_name_for_id]
                    })
                    .value()
                ;

                id_list_001 = __id_list_002;
            }

            return id_list_001;
        },

        //<editor-fold desc="left_tree">

        __left_tree_init_all_node_list() {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;
            const property_name_for_order_index = __this.init_parameter.entity_define.property_name_for_order_index;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            const left_tree = __this.$refs.left_tree;
            const all_entity_list = __this.left_tree.all_entity_list;

            const all_node_list = _.chain(all_entity_list)
                .map(function (m) {
                    return left_tree.getNode(m);
                })
                .value()
            ;
            __this.left_tree.all_node_list = all_node_list;

            __this.defer_left_tree_init_all_node_list_completed.resolve();
        },

        __left_tree_btn_add_click(node, data, $event) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;
            const property_name_for_order_index = __this.init_parameter.entity_define.property_name_for_order_index;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            const __get_id_list_for_tree_add_or_remove = __this.__get_id_list_for_tree_add_or_remove;
            const __get_tree_data_by_id_list = __this.__get_tree_data_by_id_list;

            $event.stopPropagation();

            Q.when()
                .then(function () {
                    return __this.defer_left_tree_init_all_node_list_completed.promise;
                })
                .then(function () {
                    const all_entity_list = __this.left_tree.all_entity_list;

                    const temp_value_for_v_model = __this.temp_value_for_v_model;

                    const id_list_001 = __get_id_list_for_tree_add_or_remove({node});

                    const id_list_002 = _.chain(id_list_001)
                        .filter(function (m) {
                            return !_.contains(temp_value_for_v_model, m);
                        })
                        .value()
                    ;

                    const id_list_003 = temp_value_for_v_model.concat(id_list_002);

                    const id_list_004 = _.chain(id_list_003)
                        .map(function (m) {
                            const id = m;
                            let order_index = -1;
                            const entity = _.chain(all_entity_list)
                                .find(function (m) {
                                    return m[property_name_for_id] === id;
                                })
                                .value()
                            ;
                            if (entity) {
                                order_index = entity[property_name_for_order_index];
                            }

                            return {
                                id,
                                order_index,
                            }
                        })
                        .sortBy(function (m) {
                            return m.order_index;
                        })
                        .map(function (m) {
                            const id = m.id;
                            return id;
                        })
                        .value()
                    ;

                    __this.temp_value_for_v_model = id_list_004;

                    const right_tree_data = __get_tree_data_by_id_list({
                        id_list: __this.temp_value_for_v_model,
                    });
                    __this.right_tree.data = right_tree_data;
                })
                .catch(function (ex) {
                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                })
            ;

        },

        __left_tree_filter_node_method(value, data) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;
            const property_name_for_order_index = __this.init_parameter.entity_define.property_name_for_order_index;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            if (!value) return true;
            return data[property_name_for_name].indexOf(value) !== -1;
        },

        //</editor-fold>

        //<editor-fold desc="right_tree">

        __right_tree_btn_remove_click(node, data, $event) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            const __get_id_list_for_tree_add_or_remove = __this.__get_id_list_for_tree_add_or_remove;
            const __get_tree_data_by_id_list = __this.__get_tree_data_by_id_list;

            $event.stopPropagation();

            Q.when()
                .then(function () {
                    return __this.defer_left_tree_init_all_node_list_completed.promise;
                })
                .then(function () {
                    const temp_value_for_v_model = __this.temp_value_for_v_model;

                    const id_list_001 = __get_id_list_for_tree_add_or_remove({node});

                    const id_list_002 = _.chain(temp_value_for_v_model)
                        .filter(function (m) {
                            return !_.contains(id_list_001, m);
                        })
                        .value()
                    ;

                    __this.temp_value_for_v_model = id_list_002;

                    const right_tree_data = __get_tree_data_by_id_list({
                        id_list: __this.temp_value_for_v_model,
                    });
                    __this.right_tree.data = right_tree_data;
                })
                .catch(function (ex) {
                    if (ex) {
                        const enable_log_error = !ex.disable_log_error;
                        if (enable_log_error) {
                            console.error(ex);
                            console.trace();
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                    }
                    return Q.reject(ex);
                })
            ;
        },

        __right_tree_filter_node_method(value, data, node) {
            const __this = this;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            if (!value) return true;
            return data[property_name_for_name].indexOf(value) !== -1;
        },

        //</editor-fold>

        //<editor-fold desc="dialog">

        __dialog_opened_event_handler() {
            const __this = this;
            __this.left_tree.filter_text = ``;
            __this.right_tree.filter_text = ``;
            __this.__init_tree();
            __this.__init_value_for_v_model();
        },

        //</editor-fold>

        __btn_cancel_click() {
            const __this = this;
            __this.dialog.show = false;

            const btn_cancel_click_event_handler = __this.init_parameter.btn_cancel_click_event_handler;
            if (_.isFunction(btn_cancel_click_event_handler)) {
                btn_cancel_click_event_handler();
            }
        },

        __btn_ok_click() {
            const __this = this;
            const get_selected_entity_list = __this.get_selected_entity_list;

            __this.value_for_v_model = __this.temp_value_for_v_model;
            __this.dialog.show = false;

            const btn_ok_click_event_handler = __this.init_parameter.btn_ok_click_event_handler;
            if (_.isFunction(btn_ok_click_event_handler)) {
                const selected_id_list = __this.value_for_v_model;
                const selected_entity_list = get_selected_entity_list({
                    id_list: selected_id_list,
                });

                btn_ok_click_event_handler({
                    selected_id_list,
                    selected_entity_list,
                });
            }
        },

        //--------------------------------------------------------------------------------------------------------------

        get_selected_entity_list(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};
            const id_list = pParameter.id_list || __this.value_for_v_model;

            //entity_define
            const property_name_for_id = __this.init_parameter.entity_define.property_name_for_id;
            const property_name_for_name = __this.init_parameter.entity_define.property_name_for_name;
            const property_name_for_children = __this.init_parameter.entity_define.property_name_for_children;
            const property_name_for_parent_id = __this.init_parameter.entity_define.property_name_for_parent_id;

            //node_define
            const node_property_name_for_children = __this.init_parameter.node_define.property_name_for_children;
            const node_property_name_for_parent = __this.init_parameter.node_define.property_name_for_parent;

            const all_entity_list = __this.left_tree.all_entity_list;

            const list = _.chain(all_entity_list)
                .filter(function (m) {
                    const id = m[property_name_for_id];
                    return _.contains(id_list, id) && m.isProvince === 0;
                })
                .map(function (m) {
                    return extend(true, {}, m);
                })
                .value()
            ;
            return list;
        },

        show() {
            const __this = this;
            __this.dialog.show = true
        },

        hide() {
            const __this = this;
            __this.dialog.show = false;
        },

    },

    mounted() {
        const __this = this;
        __this.__init_data_source();
    }
};
